var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgApps = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M682.005333 853.994667l0-172.010667 172.010667 0 0 172.010667-172.010667 0zM682.005333 597.994667l0-172.010667 172.010667 0 0 172.010667-172.010667 0zM426.005333 341.994667l0-172.010667 172.010667 0 0 172.010667-172.010667 0zM682.005333 170.005333l172.010667 0 0 172.010667-172.010667 0 0-172.010667zM426.005333 597.994667l0-172.010667 172.010667 0 0 172.010667-172.010667 0zM170.005333 597.994667l0-172.010667 172.010667 0 0 172.010667-172.010667 0zM170.005333 853.994667l0-172.010667 172.010667 0 0 172.010667-172.010667 0zM426.005333 853.994667l0-172.010667 172.010667 0 0 172.010667-172.010667 0zM170.005333 341.994667l0-172.010667 172.010667 0 0 172.010667-172.010667 0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgApps, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/apps.c7b9baee.svg";
export { ForwardRef as ReactComponent };